import { Controller } from "@hotwired/stimulus"

// Reloads the available-slots Turbo Frame inside the portal reschedule
// modal whenever the date picker changes. Rebuilds the frame `src` URL
// with the new `date=` value and assigns via `setAttribute` so Turbo's
// mutation observer reliably fires a fetch (the `.src` property setter
// is less consistent across browsers).
//
// Targets:
//   frame     — the <turbo-frame> hosting the slot buttons
//   dateInput — hidden datepicker input that carries the chosen date
export default class extends Controller {
  static targets = ["frame", "dateInput"]
  static values = { baseUrl: String }

  refresh() {
    if (!this.hasDateInputTarget || !this.hasFrameTarget) return
    const date = this.dateInputTarget.value
    if (!date) return

    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set("date", date)
    this.frameTarget.setAttribute("src", url.toString())
  }
}
